import React from 'react';
import {Form} from 'reactstrap';
import UserFullName from '../FormGroups/UserFullName';
import UserAdress from '../FormGroups/UserAdress';
import { Row, FormGroup, Input } from 'reactstrap';
import '../../styles/Administation.css'

class AdministrationStep extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      ...props.administration,
      checked: true,
    }
    this.submitted = false;

    this.validForm = {adressValidation: false, nameValidation: false};

    this.handleChange = this.handleChange.bind(this);
    this.isValidated = this.isValidated.bind(this);
    this.isFormValid = this.isFormValid.bind(this);
    this.handleChangeChecked = this.handleChangeChecked.bind(this);
    this.missingError= "Nur für Mietobjekte möglich, welche durch Allgemeinstrom der GASAG versorgt werden.";
  }

  handleChange(event){
    const adminInfo = this.props.administration || {};
    adminInfo[event.target.name] = event.target.value;

    this.setState({
      ...adminInfo
    });
    this.props.updateAdminInfo(adminInfo);
  }
  
  isValidated() {
    this.submitted = true;
    this.forceUpdate(); // to give the fields a first check with feedback
    if (this.props.isRegistration && this.props.type === 'electricity') {
      if(this.validForm.adressValidation && this.validForm.nameValidation && this.state.checked ) {
        return true;
      } else {
        return false;
      }
    }
    else {
      if(this.validForm.adressValidation && this.validForm.nameValidation ) {
        return true;
      } else {
        return false;
      }
    }
  }
  
  isFormValid(isValid, whereValid) {
    this.validForm[whereValid] = isValid;
  }
  handleChangeChecked(event) {
    this.setState({
        checked: !this.state.checked});
  }

  render(){
    let check;
    let checkedmsg;
    if (this.props.isRegistration && this.props.type === 'electricity') {
      if (this.submitted) {
        if (this.state.checked === false) {
            checkedmsg=
                    <span id="error1" className="help-block">{this.missingError}</span>
        }
      }
      check= 
      <div>
        <hr id="line"></hr>
          <h5 id="text">Bitte geben Sie an, ob das Mietobjekt, in dem sich die leerstehende Mietwohnung befindet,
           durch Allgemeinstrom (Treppenlicht, Fahrstuhl, etc.) der GASAG versorgt wird (Voraussetzung für die Anmeldung von STROM Leerstand). </h5>
        <hr></hr>
          <Row>
              <FormGroup check>
                <h5 id="label">
                    Ja
                </h5>
                <Input id="check1" type="checkbox" checked={this.state.checked} name="checked" onChange={this.handleChangeChecked}/>{' '}
                {checkedmsg}
              </FormGroup>
          </Row>
          <Row>
              <Input id="check2" type="checkbox" name="checked2" checked={!this.state.checked} onChange={this.handleChangeChecked}/>{' '}
              <h5 id="linktext"> Nein. Ich habe Interesse an einer
                <a id="link1" href="https://www.gasag.de/Geschaeftskunden/Strom/Allgemeinstrom">Allgemeinstrombelieferung durch die GASAG</a>
              </h5>
          </Row>
      </div>
    }
    return (
      <Form>
           {check}
        <hr></hr>
        <h5>Sie verwalten die jeweiligen Mietobjekte als Eigentümer, Wohnungsbaugesellschaft oder Hausverwaltung. Bitte tragen Sie hier Ihre Geschäftsadresse ein.</h5>
        <hr></hr>
        <UserFullName changeHandler={this.handleChange}
                      submitted={this.submitted}
                      state={this.state}
                      isValidForm={this.isFormValid} />
                      
        <UserAdress changeHandler={this.handleChange}
                    submitted={this.submitted}
                    state={this.state}
                    isValidForm={this.isFormValid} />
      </Form>
    );
  }
}

export default AdministrationStep;


// WEBPACK FOOTER //
// ./src/components/Steps/AdministrationStep.js